var t = t => "object" == typeof t && null != t && 1 === t.nodeType,
    e = (t, e) => (!e || "hidden" !== t) && "visible" !== t && "clip" !== t,
    n = (t, n) => {
  if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
    var _o = getComputedStyle(t, null);

    return e(_o.overflowY, n) || e(_o.overflowX, n) || (t => {
      var e = (t => {
        if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;

        try {
          return t.ownerDocument.defaultView.frameElement;
        } catch (t) {
          return null;
        }
      })(t);

      return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
    })(t);
  }

  return !1;
},
    o = (t, e, n, o, l, r, i, s) => r < t && i > e || r > t && i < e ? 0 : r <= t && s <= n || i >= e && s >= n ? r - t - o : i > e && s < n || r < t && s > n ? i - e + l : 0,
    l = t => {
  var e = t.parentElement;
  return null == e ? t.getRootNode().host || null : e;
},
    r = (e, r) => {
  var i, s, d, h;
  if ("undefined" == typeof document) return [];
  var {
    scrollMode: c,
    block: f,
    inline: u,
    boundary: a,
    skipOverflowHiddenElements: g
  } = r,
      p = "function" == typeof a ? a : t => t !== a;
  if (!t(e)) throw new TypeError("Invalid target");
  var m = document.scrollingElement || document.documentElement,
      w = [];
  var W = e;

  for (; t(W) && p(W);) {
    if (W = l(W), W === m) {
      w.push(W);
      break;
    }

    null != W && W === document.body && n(W) && !n(document.documentElement) || null != W && n(W, g) && w.push(W);
  }

  var b = null != (s = null == (i = window.visualViewport) ? void 0 : i.width) ? s : innerWidth,
      H = null != (h = null == (d = window.visualViewport) ? void 0 : d.height) ? h : innerHeight,
      {
    scrollX: y,
    scrollY: M
  } = window,
      {
    height: v,
    width: E,
    top: x,
    right: C,
    bottom: I,
    left: R
  } = e.getBoundingClientRect(),
      {
    top: T,
    right: B,
    bottom: F,
    left: V
  } = (t => {
    var e = window.getComputedStyle(t);
    return {
      top: parseFloat(e.scrollMarginTop) || 0,
      right: parseFloat(e.scrollMarginRight) || 0,
      bottom: parseFloat(e.scrollMarginBottom) || 0,
      left: parseFloat(e.scrollMarginLeft) || 0
    };
  })(e);

  var k = "start" === f || "nearest" === f ? x - T : "end" === f ? I + F : x + v / 2 - T + F,
      D = "center" === u ? R + E / 2 - V + B : "end" === u ? C + B : R - V;
  var L = [];

  for (var _t = 0; _t < w.length; _t++) {
    var _e = w[_t],
        {
      height: _n,
      width: _l,
      top: _r,
      right: _i,
      bottom: _s,
      left: _d
    } = _e.getBoundingClientRect();

    if ("if-needed" === c && x >= 0 && R >= 0 && I <= H && C <= b && x >= _r && I <= _s && R >= _d && C <= _i) return L;

    var _h = getComputedStyle(_e),
        _a = parseInt(_h.borderLeftWidth, 10),
        _g = parseInt(_h.borderTopWidth, 10),
        _p = parseInt(_h.borderRightWidth, 10),
        _W = parseInt(_h.borderBottomWidth, 10);

    var _T = 0,
        _B = 0;

    var _F = "offsetWidth" in _e ? _e.offsetWidth - _e.clientWidth - _a - _p : 0,
        _V = "offsetHeight" in _e ? _e.offsetHeight - _e.clientHeight - _g - _W : 0,
        S = "offsetWidth" in _e ? 0 === _e.offsetWidth ? 0 : _l / _e.offsetWidth : 0,
        X = "offsetHeight" in _e ? 0 === _e.offsetHeight ? 0 : _n / _e.offsetHeight : 0;

    if (m === _e) _T = "start" === f ? k : "end" === f ? k - H : "nearest" === f ? o(M, M + H, H, _g, _W, M + k, M + k + v, v) : k - H / 2, _B = "start" === u ? D : "center" === u ? D - b / 2 : "end" === u ? D - b : o(y, y + b, b, _a, _p, y + D, y + D + E, E), _T = Math.max(0, _T + M), _B = Math.max(0, _B + y);else {
      _T = "start" === f ? k - _r - _g : "end" === f ? k - _s + _W + _V : "nearest" === f ? o(_r, _s, _n, _g, _W + _V, k, k + v, v) : k - (_r + _n / 2) + _V / 2, _B = "start" === u ? D - _d - _a : "center" === u ? D - (_d + _l / 2) + _F / 2 : "end" === u ? D - _i + _p + _F : o(_d, _i, _l, _a, _p + _F, D, D + E, E);
      var {
        scrollLeft: _t2,
        scrollTop: _h2
      } = _e;
      _T = 0 === X ? 0 : Math.max(0, Math.min(_h2 + _T / X, _e.scrollHeight - _n / X + _V)), _B = 0 === S ? 0 : Math.max(0, Math.min(_t2 + _B / S, _e.scrollWidth - _l / S + _F)), k += _h2 - _T, D += _t2 - _B;
    }
    L.push({
      el: _e,
      top: _T,
      left: _B
    });
  }

  return L;
};

export { r as compute };